import { LazySectionAccordion, LazySectionCollection, LazySectionCollectionCarousel, LazySectionCollectionStandout, LazySectionContactForm, LazySectionHeader, LazySectionHomepageHeader, LazySectionIconCarousel, LazySectionMarketingForm, LazySectionParagraph, LazySectionStandout, LazySectionStandoutCenter, LazyUserLogin, LazyUserRegister } from '#components'
import type { Component } from 'vue'

export const SECTION_MAP: Record<string, Component> = {
  'accordion': LazySectionAccordion,
  'homepage-header': LazySectionHomepageHeader,
  'header': LazySectionHeader,
  'paragraph': LazySectionParagraph,
  'collection': LazySectionCollection,
  'collection-carousel': LazySectionCollectionCarousel,
  'collection-standout': LazySectionCollectionStandout,
  'icon-carousel': LazySectionIconCarousel,
  'standout': LazySectionStandout,
  'standout-center': LazySectionStandoutCenter,
  'contact-form': LazySectionContactForm,
  'register': LazyUserRegister,
  'login': LazyUserLogin,
  'marketing-form': LazySectionMarketingForm,
}

export const SECTION_TYPES: Array<keyof typeof SECTION_MAP> = Object.keys(SECTION_MAP) as Array<keyof typeof SECTION_MAP>
// export const PAGE_LAYOUT_TYPES = ['page', 'collection']
